module.exports = __webpack_public_path__ + "media/images/covers/prepworks-new-registration-9a92861b2d6cf4a0a854179a76798a45.jpg";